<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="-10 0 532 512"
    class="icon wardrobe"
  >
    <path
      d="m 283.31718,443.10015 -0.16617,48.73229 c -0.017,4.98369 -2.49188,7.47568 -7.47568,7.47568 h -28.24142 c -4.98377,0 -7.47567,-2.49191 -7.47567,-7.47568 v -48.56613"
    />
    <path
      d="m 127.92755,433.65334 c -8.81481,0 -16.37037,-3.14812 -22.66666,-9.44444 -6.296305,-6.29633 -9.444446,-13.85189 -9.444446,-22.66667 0,-28.96295 9.129616,-54.46291 27.388876,-76.49993 l 4.72223,-6.61113 c 13.85186,-16.37034 21.87963,-35.41664 24.08333,-57.13887 2.20371,-21.72221 -2.0463,-42.02777 -12.75,-60.91666 l -30.22222,-53.83333 c -3.77777,-6.2963 -5.66666,-12.90741 -5.66666,-19.83333 v -16.05556 c 0,-8.8148 2.67593,-16.842581 8.02777,-24.083323 5.35185,-7.240735 12.12037,-12.120367 20.30556,-14.638889 l 59.49999,-17.944442 c 11.33334,-3.777777 17.00001,-11.648143 17.00001,-23.611108 v -7.555555 c 0,-5.666666 2.83333,-8.499999 8.49999,-8.499999 h 96.33333 c 5.66667,0 8.5,2.833333 8.5,8.499999 v 7.555555 c 0,11.962965 5.66667,19.833331 17.00001,23.611108 l 59.49998,17.944442 c 8.1852,2.518522 14.9537,7.398154 20.30557,14.638889 5.35185,7.240742 8.02776,15.268523 8.02776,24.083323 v 16.05556 c 0,6.92592 -1.88888,13.53703 -5.66666,19.83333 l -30.22222,53.83333 c -10.7037,18.88889 -14.95371,39.19445 -12.74999,60.91666 2.20369,21.72223 10.23147,40.76853 24.08333,57.13887 l 4.72222,6.61113 c 18.25925,22.03702 27.38888,47.53698 27.38888,76.49993 0,8.81478 -3.14814,16.37034 -9.44444,22.66667 -6.29631,6.29632 -13.85185,9.44444 -22.66666,9.44444 z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.menu__item.router-link-active .icon {
  &.wardrobe {
    animation: strokWardrobe 0.9s reverse;
  }

  @keyframes strokWardrobe {
    100% {
      stroke-dashoffset: 1425;
    }
  }
}

.icon.wardrobe {
  width: 2em;
  height: 2em;
  stroke-width: 20pt;
  stroke-dasharray: 1425;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgWardrobe.vue